import styles from './Header.module.css';
import ISiteLink from '../links/ISiteLink';
import { BiCommentDetail, BiDownload } from 'react-icons/bi';
import { HiOutlineDocumentText, HiOutlineMail } from 'react-icons/hi';
import { downloadCSV } from '../../utils/downloadcsv';
import Environment from '../../Environment';

function Header() {
  const showDraftView = Environment._environment() !== 'prod';

  function openDraftView() {
    const url = new URL(window.location.href);
    url.searchParams.set('viewMode', 'preview');
    window.open(url.toString(), '_blank');
  }

  return (
    <header>
      <div>
        <img
          src="/images/naicLogo_brandmark-nav.png"
          className={styles.naicLogo_brandmark_nav}
          alt="NAIC Brandmark"
        />
        <img
          src="/images/naicLogo_tagline-nav.png"
          className={styles.naicLogo_tagline_nav}
          alt="NAIC Tag Line"
        />
      </div>
      <div className={styles.linksContainer}>
        <span id="download-link" className={styles.link}>
          <BiDownload />
          <button
            data-testid="csv-download-button"
            onClick={(e) => {
              e.preventDefault();
              downloadCSV();
            }}>
            Export CSV Report
          </button>
        </span>
        {showDraftView && (
          <span id="draft-view-link" className={styles.link}>
            <HiOutlineDocumentText />
            <button
              data-testid="draft-view-button"
              onClick={openDraftView}>
              FPR Draft View
            </button>
          </span>
        )}
        <span id="feedback-link" className={styles.link}>
          <BiCommentDetail />
          <a
            href="mailto:profilefeedback@naic.org?Subject=Profile%20Report%20Feedback"
            target="_blank"
            rel="noopener noreferrer">
            Submit Feedback
          </a>
        </span>
        <span id="help-link" className={styles.link}>
          <HiOutlineDocumentText />
          <a target="_blank" href="/documents/Financial-Profile-Users-Guide.pdf">
            User Guide & FAQs
          </a>
        </span>
        <span id="email-link" className={styles.link}>
          <HiOutlineMail />
          <ISiteLink relativeUrl={'/secure/html/mailform.htm'} label={'Email'}></ISiteLink>
        </span>
      </div>
    </header>
  );
}

export default Header;
